import React from 'react';
import {Link} from 'react-router-dom';
import {ROUTES} from '../../contants';

import {ReactComponent as TruckIcon} from '../../assets/images/icon/Truck.svg';
import {ReactComponent as EmployeesIcon} from '../../assets/images/icon/Employees.svg';
import {ReactComponent as MapIcon} from '../../assets/images/icon/Map.svg';
import {ReactComponent as SupportIcon} from '../../assets/images/icon/Support.svg';
import {ReactComponent as LineIcon} from '../../assets/images/icon/wave-line.svg';
import homeServicesImg from '../../assets/images/home-services.jpg';


export const HomeServices = () => (
  <>
    <div className="home-services">
      <div className="container">
        <div className="home-services__wr">
          <div className="home-services__content">
            <h2>Services</h2>
            <p>
              Our company offers more than just transportation services; we provide comprehensive solutions designed to 
              meet your unique needs. By managing every aspect with efficiency and precision, we ensure a seamless 
              experience that allows you to concentrate on your core business with complete confidence and peace of mind
            </p>
            <Link to={ROUTES.SERVICES} className="btn btn--white">
              <span>CHECK OUR SERVICES</span>
            </Link>
          </div>
          <div className="home-services__list">
            <div className="home-services__item">
              <div className="home-services__icon">
                <TruckIcon />
              </div>
              <div className="home-services__content">
                <div className="home-services__content_title">100+</div>
                <div className="home-services__content_text">100+ trucks across the US</div>
              </div>
            </div>
            <div className="home-services__item">
              <div className="home-services__icon">
                <EmployeesIcon />
              </div>
              <div className="home-services__content">
                <div className="home-services__content_title">150+</div>
                <div className="home-services__content_text">Employees</div>
              </div>
            </div>
            <div className="home-services__item">
              <div className="home-services__icon">
                <MapIcon />
              </div>
              <div className="home-services__content">
                <div className="home-services__content_title">48</div>
                <div className="home-services__content_text">US states</div>
              </div>
            </div>
            <div className="home-services__item">
              <div className="home-services__icon">
                <SupportIcon />
              </div>
              <div className="home-services__content">
                <div className="home-services__content_title">24/7</div>
                <div className="home-services__content_text">Support</div>
              </div>
            </div>
          </div>
          <div className="home-services__image">
            <img src={homeServicesImg} alt="homeServicesImg" />
          </div>
        </div>
      </div>
    </div>
    <div className="home-desc">
      <div className="container">
        <div className="home-desc__wr">
          <LineIcon />
          <h2>
            With V Line Inc your freights will <br /> be shipped to any state of the USA <br />
            safely and on time
          </h2>
          <LineIcon />
        </div>
      </div>
    </div>
  </>
);
